import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "./services/api";
import { usersApi } from "./services/users";
import { tenantsApi } from "./services/tenants";
import { eventsApi } from "./services/events";
import { notificationsApi } from "./services/notifications";
import { cometchatApi } from "./services/cometchat";
import { reportsApi } from "./services/reports";
import { venuesApi } from "./services/venues";
import { workshopsApi } from "./services/workshops";
import { photoReportsApi } from "./services/photo-reports";
import { benefitsApi } from "./services/benefits";
import eventsFiltersReducer from "./slices/eventsFiltersSlice";
import usersFiltersReducer from "./slices/usersFiltersSlice";
import workshopsFiltersReducer from "./slices/workshopsFiltersSlice";

export const store = configureStore({
  reducer: {
    eventsFilters: eventsFiltersReducer,
    usersFilters: usersFiltersReducer,
    workshopsFilters: workshopsFiltersReducer,
    [api.reducerPath]: api.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [tenantsApi.reducerPath]: tenantsApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [cometchatApi.reducerPath]: cometchatApi.reducer,
    [reportsApi.reducerPath]: reportsApi.reducer,
    [venuesApi.reducerPath]: venuesApi.reducer,
    [workshopsApi.reducerPath]: workshopsApi.reducer,
    [photoReportsApi.reducerPath]: photoReportsApi.reducer,
    [benefitsApi.reducerPath]: benefitsApi.reducer,
  },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      api.middleware,
      usersApi.middleware
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
